import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import App from '../App';


import { getAuthUser } from '../actions/userActions';

const mapStateToProps = state => ({ user: state.user });

const mapDispatchToProps = { getAuthUser };


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/pages/App.js